 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Apply":"Apply","Applylist":"Applylist","Bhlist":"Bhlist","Buylist":"Buylist","Casting":"Casting","Castinglist":"Castinglist","Choosenft":"Choosenft","Collectionshop":"Collectionshop","Copyrightlist":"Copyrightlist","Createcollection":"Createcollection","Crosschainlist":"Crosschainlist","Crosschain~LpPlege~Nftdetail~Synthesis~Upinfo~newdetail":"Crosschain~LpPlege~Nftdetail~Synthesis~Upinfo~newdetail","Crosschain":"Crosschain","LpPlege":"LpPlege","Nftdetail":"Nftdetail","Synthesis":"Synthesis","Test~newdetail":"Test~newdetail","newdetail":"newdetail","Upinfo":"Upinfo","Exchange":"Exchange","Exchangelist":"Exchangelist","Globalnode":"Globalnode","Hashrate":"Hashrate","Home":"Home","Included":"Included","Introduce":"Introduce","Invite":"Invite","Jslist":"Jslist","Leaderboard":"Leaderboard","Lpfxlist":"Lpfxlist","Lpnode":"Lpnode","Lpsflist":"Lpsflist","Lpzylist":"Lpzylist","Minelists":"Minelists","Mints":"Mints","Mpquery":"Mpquery","My":"My","Myinfo":"Myinfo","Nftshop":"Nftshop","Nodedetail":"Nodedetail","Nodepush1":"Nodepush1","Nodepush2":"Nodepush2","Notice":"Notice","Pledge":"Pledge","Pledgedetail":"Pledgedetail","Pledgeitem":"Pledgeitem","Pledgelist":"Pledgelist","Question":"Question","Rankinglist":"Rankinglist","Receivelist":"Receivelist","Redemptionlist":"Redemptionlist","Search":"Search","Set":"Set","Sort":"Sort","Syntheticlist":"Syntheticlist","Test":"Test","new_more":"new_more"}[chunkId]||chunkId) + "." + {"Apply":"be766b25","Applylist":"61bd8fbc","Bhlist":"b9632eb6","Buylist":"214677aa","Casting":"bcc14319","Castinglist":"78d94838","Choosenft":"8da52cac","Collectionshop":"8faf9be3","Copyrightlist":"c689916e","Createcollection":"5ed98970","Crosschainlist":"a6fc080a","Crosschain~LpPlege~Nftdetail~Synthesis~Upinfo~newdetail":"9a6fa67d","Crosschain":"91cc72ff","LpPlege":"559451d8","Nftdetail":"a84b8ae1","Synthesis":"a6d78275","Test~newdetail":"286c5f7e","newdetail":"ac3d5989","Upinfo":"4fd6019d","Exchange":"21c35ecd","Exchangelist":"6e741692","Globalnode":"ec5564c3","Hashrate":"2bd7ae5e","Home":"dd6794c2","Included":"1e317249","Introduce":"f6b67900","Invite":"9cd0cb0d","Jslist":"5fb5ff66","Leaderboard":"f648e6f2","Lpfxlist":"1b4a1ff6","Lpnode":"9c1a99d7","Lpsflist":"aef59b3a","Lpzylist":"4ce735f8","Minelists":"63b82813","Mints":"848ffe77","Mpquery":"cdd5a040","My":"37405955","Myinfo":"3375cdd7","Nftshop":"6b22c295","Nodedetail":"7f1ef40a","Nodepush1":"d411c7ed","Nodepush2":"b51de04e","Notice":"59b349e4","Pledge":"4ae24ce8","Pledgedetail":"c57d97e2","Pledgeitem":"032438d5","Pledgelist":"1c1d5e94","Question":"c9896a0f","Rankinglist":"6b554ab2","Receivelist":"9045f346","Redemptionlist":"41b01589","Search":"61867322","Set":"42ed057d","Sort":"9ba65eb3","Syntheticlist":"3e34dc13","Test":"c47167bb","new_more":"72d6af70"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Apply":1,"Applylist":1,"Bhlist":1,"Buylist":1,"Casting":1,"Castinglist":1,"Choosenft":1,"Collectionshop":1,"Copyrightlist":1,"Createcollection":1,"Crosschainlist":1,"Crosschain":1,"LpPlege":1,"Nftdetail":1,"Synthesis":1,"newdetail":1,"Upinfo":1,"Exchange":1,"Exchangelist":1,"Globalnode":1,"Hashrate":1,"Home":1,"Included":1,"Introduce":1,"Invite":1,"Jslist":1,"Leaderboard":1,"Lpfxlist":1,"Lpnode":1,"Lpsflist":1,"Lpzylist":1,"Minelists":1,"Mints":1,"Mpquery":1,"My":1,"Myinfo":1,"Nftshop":1,"Nodedetail":1,"Nodepush1":1,"Nodepush2":1,"Notice":1,"Pledge":1,"Pledgedetail":1,"Pledgeitem":1,"Pledgelist":1,"Question":1,"Rankinglist":1,"Receivelist":1,"Redemptionlist":1,"Search":1,"Set":1,"Sort":1,"Syntheticlist":1,"Test":1,"new_more":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Apply":"Apply","Applylist":"Applylist","Bhlist":"Bhlist","Buylist":"Buylist","Casting":"Casting","Castinglist":"Castinglist","Choosenft":"Choosenft","Collectionshop":"Collectionshop","Copyrightlist":"Copyrightlist","Createcollection":"Createcollection","Crosschainlist":"Crosschainlist","Crosschain~LpPlege~Nftdetail~Synthesis~Upinfo~newdetail":"Crosschain~LpPlege~Nftdetail~Synthesis~Upinfo~newdetail","Crosschain":"Crosschain","LpPlege":"LpPlege","Nftdetail":"Nftdetail","Synthesis":"Synthesis","Test~newdetail":"Test~newdetail","newdetail":"newdetail","Upinfo":"Upinfo","Exchange":"Exchange","Exchangelist":"Exchangelist","Globalnode":"Globalnode","Hashrate":"Hashrate","Home":"Home","Included":"Included","Introduce":"Introduce","Invite":"Invite","Jslist":"Jslist","Leaderboard":"Leaderboard","Lpfxlist":"Lpfxlist","Lpnode":"Lpnode","Lpsflist":"Lpsflist","Lpzylist":"Lpzylist","Minelists":"Minelists","Mints":"Mints","Mpquery":"Mpquery","My":"My","Myinfo":"Myinfo","Nftshop":"Nftshop","Nodedetail":"Nodedetail","Nodepush1":"Nodepush1","Nodepush2":"Nodepush2","Notice":"Notice","Pledge":"Pledge","Pledgedetail":"Pledgedetail","Pledgeitem":"Pledgeitem","Pledgelist":"Pledgelist","Question":"Question","Rankinglist":"Rankinglist","Receivelist":"Receivelist","Redemptionlist":"Redemptionlist","Search":"Search","Set":"Set","Sort":"Sort","Syntheticlist":"Syntheticlist","Test":"Test","new_more":"new_more"}[chunkId]||chunkId) + "." + {"Apply":"6a3dbd56","Applylist":"561b47a3","Bhlist":"20c401d0","Buylist":"4319ba3a","Casting":"a7e2af99","Castinglist":"95231cdc","Choosenft":"730e38a2","Collectionshop":"5d19e6c0","Copyrightlist":"ee74ee80","Createcollection":"592e1aa9","Crosschainlist":"5ff2c3f5","Crosschain~LpPlege~Nftdetail~Synthesis~Upinfo~newdetail":"31d6cfe0","Crosschain":"3900e1c4","LpPlege":"481ea30e","Nftdetail":"f8dd4cc4","Synthesis":"83b4a031","Test~newdetail":"31d6cfe0","newdetail":"257e1a12","Upinfo":"1a2a7215","Exchange":"a93b2e65","Exchangelist":"b9f912ce","Globalnode":"b471986d","Hashrate":"b0f9b888","Home":"fc7a13bb","Included":"2f86e121","Introduce":"afac2b22","Invite":"01e83102","Jslist":"2450e1cf","Leaderboard":"fcd6baf0","Lpfxlist":"2f713387","Lpnode":"91b4de3f","Lpsflist":"dcac13a5","Lpzylist":"b58418ac","Minelists":"89363fac","Mints":"b5ab905a","Mpquery":"58f75578","My":"c08bb9a3","Myinfo":"3968cc20","Nftshop":"63ca720f","Nodedetail":"3f91e136","Nodepush1":"d9e9b59f","Nodepush2":"f9acf915","Notice":"62162183","Pledge":"23c730ad","Pledgedetail":"ba402bdd","Pledgeitem":"0eb65643","Pledgelist":"ae8d1435","Question":"d4c2b0cb","Rankinglist":"1ea3819b","Receivelist":"1456dda7","Redemptionlist":"6200c33a","Search":"ef3ac457","Set":"dee045e7","Sort":"15cde404","Syntheticlist":"40b271cb","Test":"10a2409f","new_more":"70797b3b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
